import { render } from "./SidebarCollapse.vue?vue&type=template&id=569c4ac1"
import script from "./SidebarCollapse.vue?vue&type=script&lang=js"
export * from "./SidebarCollapse.vue?vue&type=script&lang=js"

import "./SidebarCollapse.vue?vue&type=style&index=0&id=569c4ac1&lang=css"

import exportComponent from "/Users/bobbarnard/Documents/sources/bungalow7-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__